var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
var SetApprovedComponent = /** @class */ (function (_super) {
    __extends(SetApprovedComponent, _super);
    function SetApprovedComponent(fb, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.dialogRef = dialogRef;
        _this.eventApproved = data.eventApproved;
        _this.placeApproved = data.placeApproved;
        _this.jobApproved = data.jobApproved;
        return _this;
    }
    SetApprovedComponent.prototype.ngOnInit = function () {
        this.hubApprovedForm = this.fb.group({
            eventApproved: [this.eventApproved, []],
            placeApproved: [this.placeApproved, []],
            jobApproved: [this.jobApproved, []],
        });
    };
    SetApprovedComponent.prototype.save = function () {
        this.dialogRef.close(this.hubApprovedForm.value);
    };
    SetApprovedComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return SetApprovedComponent;
}(BaseComponent));
export { SetApprovedComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.approved/set.approved.component.ts.pre-build-optimizer.js